
import Bed from '@/assets/icons/fontawesome/duotone/bed.svg?inline'
import Gift from '@/assets/icons/fontawesome/duotone/gift.svg?inline'
import Wifi from '@/assets/icons/fontawesome/light/wifi.svg?inline'
import Plus from '@/assets/icons/fontawesome/light/plus.svg?inline'
import Images from '@/assets/icons/fontawesome/light/images.svg?inline'
import BedAlt from '@/assets/icons/fontawesome/light/bed-alt.svg?inline'
import Coffee from '@/assets/icons/fontawesome/duotone/coffee.svg?inline'
import ThumbsUp from '@/assets/icons/fontawesome/regular/thumbs-up.svg?inline'
import SmokingBan from '@/assets/icons/fontawesome/light/smoking-ban.svg?inline'
import UserFriends from '@/assets/icons/fontawesome/duotone/user-friends.svg?inline'
import UtensilsAlt from '@/assets/icons/fontawesome/duotone/utensils-alt.svg?inline'
import ExternalLink from '@/assets/icons/fontawesome/light/external-link.svg?inline'
import ExpandArrows from '@/assets/icons/fontawesome/light/expand-arrows.svg?inline'

export default {
  components: {
    Bed,
    Gift,
    Wifi,
    Plus,
    Images,
    BedAlt,
    Coffee,
    ThumbsUp,
    SmokingBan,
    UserFriends,
    UtensilsAlt,
    ExternalLink,
    ExpandArrows,
  },
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    sending: {
      type: Boolean,
      required: false,
    },
    cartresultcode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      roomType: null,
      modalOpen: false,
      showRooms: false,
      showRoomsTypes: [],
    }
  },
  computed: {
    hotelCity() {
      if (this.hotel.aggregator === 'innstant') {
        return this.hotel.city.slug
      }

      return null
    },
    hotelCountry() {
      return this.hotel.country.slug
    },
  },
  watch: {
    window: {
      deep: true,
      handler(newSize, oldSize) {
        if (newSize.width > 1023) {
          this.showRooms = true
        } else {
          this.showRooms = false
        }
      },
    },
  },
  mounted() {
    this.handleResize()

    window.addEventListener('resize', this.handleResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    openRoom(room) {
      this.roomType = room
      this.modalOpen = true
    },
    toggleRooms(name) {
      if (this.showRoomsTypes.includes(name)) {
        this.showRoomsTypes.splice(this.showRoomsTypes.indexOf(name), 1)
      } else {
        this.showRoomsTypes.push(name)
      }
    },
    openRemarks(code) {
      this.$emit('open-remarks', code)
    },
    openCart(result) {
      this.$emit('open-cart', result)
    },
    openQuote(result) {
      this.$emit('open-quote', result)
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
  },
}
